import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";

const regionalDirectorColumns = ({ navigate, handleDeleteAction }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Region",
      selector: ({ region }) => region,
      identifier: "region",
      grow: 2,
      sortable: true,
      cell: ({ region }) => <CellText>{region?.name || ""}</CellText>,
    },
    {
      name: "Name",
      selector: ({ name }) => name,
      identifier: "name",
      grow: 2,
      sortable: true,
      cell: ({ name, firstName, lastName }) => (
        <CellText>
          {firstName && lastName ? `${firstName} ${lastName}` : name || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "Cos",
      selector: ({ cosName }) => cosName,
      identifier: "cosName",
      grow: 2,
      sortable: true,
      cell: ({ cosFirstName, cosLastName, cosName }) => (
        <CellText>
          {cosFirstName && cosLastName
            ? `${cosFirstName} ${cosLastName}`
            : cosName || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ cosContact }) => cosContact,
      identifier: "cosContact",
      grow: 2,
      sortable: true,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row) => (
        <>
          {hasPermission("regional-director-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id}`}
                onClick={() => {
                  navigate("/director", {
                    state: {
                      director: row,
                    },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="top"
                target={`edit-row--${row.id}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("regional-director-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default regionalDirectorColumns;
